import { render, staticRenderFns } from "./YoungChat.vue?vue&type=template&id=7c39f8bb&scoped=true&"
import script from "./YoungChat.vue?vue&type=script&lang=js&"
export * from "./YoungChat.vue?vue&type=script&lang=js&"
import style0 from "./YoungChat.vue?vue&type=style&index=0&id=7c39f8bb&prod&scoped=true&lang=css&"
import style1 from "./YoungChat.vue?vue&type=style&index=1&id=7c39f8bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c39f8bb",
  null
  
)

export default component.exports